import React, { FC, PropsWithChildren } from 'react';

type StarHalfProps = {
  /** The color of the icon. */
  color?: string;
};

const StarHalf: FC<PropsWithChildren<StarHalfProps>> = ({ color = 'currentcolor' }) => (
  <svg
    height="22.487"
    version="1.1"
    viewBox="0 0 6.3502642 5.9496854"
    width="24.000999"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m 3.1750698,0.1874574 0.7486703,2.1212331 h 2.246011 L 4.422853,3.6812525 5.0467458,5.8024861 3.1750698,4.5547018 1.3033936,5.8024861 1.9272854,3.6812525 0.18038807,2.3086905 H 2.4263993 Z"
      fill="none"
      stroke={color}
      strokeWidth="0.35"
    />
    <path
      d="m 3.1750698,0.18745739 c 0,4.36724441 0,10e-9 0,4.36724441 L 1.3033936,5.8024861 1.9272854,3.6812525 0.1803881,2.3086905 h 2.2460112 z"
      fill={color}
      stroke={color}
      strokeWidth="0.35"
    />
  </svg>
);

export default StarHalf;
